module.exports = __webpack_public_path__ + "static/img/4.36728e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/4.png
// module id = VSfF
// module chunks = 0